import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from "../../client-server-common/doppe-action-types/doppe-action-type";
import {DoppeActionTypeContentSpecialSettingsMetadata} from "../../client-server-common";
import type {Values} from '@wix/devzai-utils-common';

export const DoppeActionTypePlaceholderSkeletonAnimation = {
    None: 'None',
    Shimmer: 'Shimmer',
} as const;

export type DoppeActionTypePlaceholderSkeletonAnimation = Values<typeof DoppeActionTypePlaceholderSkeletonAnimation>;

export interface DoppeActionTypePlaceholderSettings {
    skeletonAnimation: DoppeActionTypePlaceholderSkeletonAnimation;
}

export const doppeActionTypePlaceholder = doppeActionTypeDefineMetadata<DoppeActionTypePlaceholderSettings>({
    id: 'io.bymo.action/placeholder',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        skeletonAnimation: DoppeActionTypePlaceholderSkeletonAnimation.None,
    }),
    actionSettingsMetadata: {
        contentSettingsMetadata: DoppeActionTypeContentSpecialSettingsMetadata.Ignored,
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {},
        bindableContentSettingsNames: {}
    },
    actionListItemSettingsMetadata: false,
    canRenderInPage: true,
    isWidgetOpener: true
})
